const findFeedValue = (value, feeds = []) => {
  let feedValue = null
  feeds.forEach(feed => {
    if (feed.name === value) {
      feedValue = feed
    }
  })
  return feedValue
}

export { findFeedValue }
